module.exports = __webpack_public_path__ + "img/xd.5e66e8eb.svg";